import React from "react";
import ArrowRightAltIcon from "@mui/material/SvgIcon/SvgIcon";
import {formatCurrency} from "../../utils";

function ExchangeListItem({item: r}) {
  const numberStyle = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }
  const lbpFormatted = formatCurrency(r.lbp, 'LBP', numberStyle);
  const usdFormatted = formatCurrency(r.usd, 'USD', numberStyle);
  let used = Math.min(r.lbp, r.used);
  const rateFormatted = formatCurrency(r.rate, 'LBP', numberStyle);
  let usedPercent = 100 - r.remaining;
  if (r.totalRemaining <= 0) {
    usedPercent = 100;
  }
  // let usedPercent = Math.min(r.used / r.lbp, 1) * 100;
  if (usedPercent >= 98.5) {
    usedPercent = 100;
    used = r.lbp;
  }
  usedPercent = Math.round(usedPercent);

  const usedFormatted = formatCurrency(used, 'LBP', numberStyle) || 0;
  return (<div key={r.rowNumber} className="exchange-row">
    <span className="date">{new Intl.DateTimeFormat('en-US').format(r.date)}</span>
    <span className="amount-origin">{usdFormatted}</span>
    <span className="amount-conversion"><ArrowRightAltIcon fontSize="large" /></span>
    <span className="amount-rate">{rateFormatted}</span>
    <span className="amount-result">{lbpFormatted}</span>
    <span className="amount-used">{usedFormatted} used</span>
    {!isNaN(usedPercent) && usedPercent ?
      <span className="used-progress" style={{height: `${usedPercent}%`}}>&nbsp;{usedPercent}%</span>
      : null}
  </div>)
}

export default ExchangeListItem;
